
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Punetomahabaleshwartempotraveller() {



    const cardData =
    {
        keyword: 'Pune to Mahabaleshwar Tempo Traveller',
        heading: 'Samarth Travels: Pune to Mahabaleshwar Tempo Traveller',
        headingDescription: 'Samarth Travels offers Tempo Traveller from Pune to Mahabaleshwar, ideal for group vacations, family trips, and weekend getaways to the hills. Our comfortable Tempo Travellers are equipped with air-conditioning, push-back seats, and spacious interiors to make your journey through the scenic Western Ghats smooth and enjoyable. With skilled drivers, fair pricing, and a focus on safety, Samarth Travels ensures a relaxing and memorable Pune to Mahabaleshwar travel experience.',

        top: 'Top Places to Visit in Pune Outstation with Samarth Travels',

      "topPlaces": [
    {
      "title": "Arthur’s Seat",
      "description": "Known as the 'Queen of Points', Arthur’s Seat offers panoramic views of the deep valleys of the Brahma-Arayana and the Savitri River. Located at an elevation of 1,470 meters, this viewpoint is famous for its unique rock formations and the optical illusion where light objects thrown into the valley are said to float back up due to air pressure. It's a must-visit spot for nature enthusiasts and photographers."
    },
    {
      "title": "Elephant’s Head Point",
      "description": "Resembling the shape of an elephant’s head and trunk, this natural rock formation is one of the most picturesque viewpoints in Mahabaleshwar. Also known as Needle's Point, it offers stunning views of the Sahyadri ranges and is best visited during sunrise or sunset for a serene experience."
    },
    {
      "title": "Venna Lake",
      "description": "Constructed in 1842 by Shri Appasaheb Maharaj, Venna Lake is a popular tourist attraction surrounded by lush greenery. Visitors can enjoy boating on the lake or horse riding along its banks. The area is also dotted with food stalls offering local delicacies, making it a perfect spot for family outings."
    },
    {
      "title": "Mahabaleshwar Temple",
      "description": "An ancient temple dedicated to Lord Shiva, the Mahabaleshwar Temple is a significant pilgrimage site. Built in the 16th century in the Hemadant style of architecture, it houses a 6-foot-long 'Swayambhu' (self-originated) Shiva Linga. The temple's serene ambiance and historical significance attract devotees and tourists alike."
    },
    {
      "title": "Mapro Garden",
      "description": "Situated on the Mahabaleshwar-Panchgani road, Mapro Garden is a delightful spot known for its strawberry plantations and a variety of fruit-based products. Visitors can relish fresh strawberry shakes, ice creams, and sandwiches. The garden also hosts the annual Strawberry Festival, featuring folk dances and music."
    },
    {
      "title": "Lingmala Waterfall",
      "description": "Located around 6 kilometers from Mahabaleshwar, Lingmala Waterfall is a mesmerizing sight, especially during the monsoon season. The main waterfall plunges from a height of 600 feet, creating a spectacular view. A smaller waterfall nearby is suitable for swimming, making it a favorite among tourists."
    },
    {
      "title": "Wilson Point",
      "description": "As the highest point in Mahabaleshwar at 1,439 meters, Wilson Point offers breathtaking views of the sunrise. Named after Sir Leslie Wilson, the then Governor of Bombay, this spot provides a panoramic view of the surrounding hills and valleys, making it a popular destination for early morning visitors."
    },
    {
      "title": "Pratapgad Fort",
      "description": "Approximately 24 kilometers from Mahabaleshwar, Pratapgad Fort is a historical site where the famous battle between Chhatrapati Shivaji Maharaj and Afzal Khan took place in 1659. The fort stands at 1,080 meters above sea level and offers panoramic views of the surrounding landscapes. It houses temples, watchtowers, and a statue of Shivaji Maharaj."
    },
    {
      "title": "Chinaman’s Falls",
      "description": "Once the site of a garden maintained by Chinese prisoners, Chinaman’s Falls is one of the most significant waterfalls in Mahabaleshwar. Cascading down from a height amidst dense greenery, it's a captivating sight, especially during the monsoon season."
    },
    {
      "title": "Dhobi Waterfall",
      "description": "Connecting Lodwick and Elphinstone points, Dhobi Waterfall is a serene spot surrounded by lush vegetation and rocky terrains. The waterfall flows into the Koyna River and is an ideal location for nature lovers seeking tranquility away from the bustling tourist spots."
    }
  ],

"services": [
    {
        "name": "Pune to Mahabaleshwar Tempo Traveller",
        "description": "Enjoy a scenic and comfortable journey from Pune to Mahabaleshwar with Samarth Travels’ Tempo Traveller services. Whether it's a weekend getaway or a family tour, our vehicles come with spacious seating, air-conditioning, and experienced drivers who ensure a smooth ride through the winding ghats."
    },
    {
        "name": "Tempo Traveller from Pune to Mahabaleshwar",
        "description": "Samarth Travels provides reliable and affordable Tempo Travellers for travel from Pune to Mahabaleshwar. Our vehicles are ideal for family trips, group tours, or corporate outings, ensuring everyone travels together in comfort and safety."
    },
    {
        "name": "Pune to Mahabaleshwar Tempo Traveller Hire",
        "description": "Hire a Tempo Traveller from Pune to Mahabaleshwar with flexible rental options, including per km rates and custom tour packages. Choose from 13-seater, 17-seater, or 20-seater vehicles, each equipped with push-back seats, AC, and ample legroom."
    },
    {
        "name": "Pune to Panchgani Tempo Traveller",
        "description": "Travel to the serene hill station of Panchgani with Samarth Travels’ Pune to Panchgani Tempo Traveller services. Whether you're planning a school picnic, family tour, or romantic escape, our fleet ensures comfort, reliability, and timely service."
    },
    {
        "name": "Tempo Traveller for Rent in Pune",
        "description": "Looking to rent a Tempo Traveller in Pune? Samarth Travels offers a range of vehicles perfect for city tours, outstation trips, weddings, and business travel. Our well-maintained fleet and courteous drivers ensure a worry-free travel experience."
    },
    {
        "name": "Tempo Traveller 17 Seater for Mahabaleshwar Trip",
        "description": "For medium-sized groups heading to Mahabaleshwar, our 17-seater Tempo Traveller is the perfect choice. With luxurious seating, air-conditioning, and plenty of luggage space, it ensures a comfortable journey through the hills and valleys of Maharashtra."
    },
    {
        "name": "17 Seater Tempo Traveller for Mahabaleshwar Tour Package",
        "description": "Book a 17-seater Tempo Traveller as part of our Mahabaleshwar tour package from Pune. Samarth Travels offers custom tour plans, including sightseeing at Venna Lake, Mapro Garden, Arthur's Seat, and nearby attractions — all in one comfortable trip."
    },
    {
        "name": "Pune Airport to Mahabaleshwar Tempo Traveller on Rent",
        "description": "Arriving at Pune Airport and heading straight to Mahabaleshwar? Samarth Travels provides direct Tempo Traveller rentals from Pune Airport with prompt pickup and reliable service for groups traveling to the hills."
    },
    {
        "name": "Pune to Tapola Tempo Traveller on Rent",
        "description": "Explore the ‘Mini Kashmir’ of Maharashtra by renting a Tempo Traveller from Pune to Tapola. Perfect for nature lovers and adventure seekers, our vehicles offer a relaxing ride with professional drivers familiar with the Tapola route."
    },
    {
        "name": "14 Seater Tempo Traveller for Maharashtra Trip",
        "description": "Travel across Maharashtra in comfort with our 14-seater Tempo Traveller. Ideal for family trips, cultural tours, or religious pilgrimages, these vehicles offer modern amenities and spacious interiors for a pleasant travel experience."
    },
    {
        "name": "Tempo Traveller on Rent for Mahabaleshwar Outings",
        "description": "Plan your Mahabaleshwar outing with ease by renting a Tempo Traveller from Samarth Travels. Whether it's a one-day tour or a full weekend trip, we offer clean, reliable, and comfortable vehicles with trained drivers who know the best local spots."
    },
    {
        "name": "Mini Bus on Rent for Mahabaleshwar Trip",
        "description": "Need a larger vehicle for your Mahabaleshwar trip? Samarth Travels offers mini buses with seating for up to 25 passengers, perfect for school groups, corporate teams, or large families. All vehicles are equipped for comfort and long-distance travel."
    },
    {
        "name": "Pune Station to Mahabaleshwar Tempo Traveller on Rent",
        "description": "Book a Tempo Traveller from Pune Railway Station to Mahabaleshwar with Samarth Travels. We offer punctual pick-up services, route flexibility, and knowledgeable drivers to ensure your hill station trip starts off hassle-free."
    },
    {
        "name": "Pune to Panchgani Tempo Traveller on Rent",
        "description": "Rent a Tempo Traveller from Pune to Panchgani for weekend retreats, educational tours, or couple trips. We offer various seating options to match your group size and ensure a relaxed drive through the scenic western ghats."
    },
    {
        "name": "Pune Tempo Traveller Hire for Outstation",
        "description": "Samarth Travels specializes in outstation Tempo Traveller rentals from Pune. Whether you’re heading to Mahabaleshwar, Goa, Shirdi, or any destination in Maharashtra, we ensure reliable, safe, and convenient travel for your entire group."
    },
    {
        "name": "Samarth Travels Tempo Traveller",
        "description": "Samarth Travels is your trusted provider of Tempo Traveller rentals in Pune. With a wide range of vehicles, experienced drivers, and flexible rental plans, we make group travel easy — be it for tourism, events, or business."
    }
],
"tableData": [
    ["Pune to Mahabaleshwar Tempo Traveller", "Tempo Traveller from Pune to Mahabaleshwar"],
    ["Pune to Mahabaleshwar Tempo Traveller Hire", "Pune to Panchgani Tempo Traveller"],
    ["Tempo Traveller for Rent in Pune", "Tempo Traveller 17 Seater for Mahabaleshwar Trip"],
    ["17 Seater Tempo Traveller for Mahabaleshwar Tour Package", "Pune Airport to Mahabaleshwar Tempo Traveller on Rent"],
    ["Pune to Tapola Tempo Traveller on Rent", "14 Seater Tempo Traveller for Maharashtra Trip"],
    ["Tempo Traveller on Rent for Mahabaleshwar Outings", "Mini Bus on Rent for Mahabaleshwar Trip"],
    ["Pune Station to Mahabaleshwar Tempo Traveller on Rent", "Pune to Panchgani Tempo Traveller on Rent"],
    ["Pune Tempo Traveller Hire for Outstation", "Samarth Travels Tempo Traveller"]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Tempo Traveller Hire for Pune to Mahabaleshwar Trip",
        "WhyChoosedescription": "We offer trusted Tempo Traveller rental services for your Pune to Mahabaleshwar trip. Whether it's a family getaway, a corporate outing, or a group tour, our Tempo Travellers provide a smooth, comfortable, and safe journey to Mahabaleshwar."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Tempo Travellers for Long-Distance Travel",
        "WhyChoosedescription": "Our Tempo Travellers are designed for long-distance travel, offering spacious and comfortable seating for your group. With air-conditioning, ample legroom, and cushioned seats, your journey from Pune to Mahabaleshwar will be comfortable and enjoyable."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Safe and Timely Travel to Mahabaleshwar",
        "WhyChoosedescription": "Our professional and experienced drivers are familiar with the Pune to Mahabaleshwar route, ensuring a smooth and timely journey. They prioritize your safety and comfort, making sure you arrive at your destination without any hassle."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing for Pune to Mahabaleshwar Rentals",
        "WhyChoosedescription": "We offer affordable and transparent pricing for your Tempo Traveller rental from Pune to Mahabaleshwar. No hidden charges and flexible rental packages make sure you get the best value for your trip while staying within your budget."
    },
    {
        "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
        "WhyChoosedescription": "Our Tempo Traveller services are available 24/7, providing you the flexibility to schedule your Pune to Mahabaleshwar trip at any time. Whether it's an early morning start or a late-night return, we ensure reliable and timely service."
    },
    {
        "WhyChooseheading": "Simple Booking Process and Real-Time Updates for Smooth Travel",
        "WhyChoosedescription": "Booking your Tempo Traveller for the Pune to Mahabaleshwar trip is quick and hassle-free. Once your booking is confirmed, you'll receive real-time updates, driver contact information, and van arrival details, ensuring seamless coordination during your trip."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Tempo Travellers for Safety",
        "WhyChoosedescription": "Our Tempo Travellers are regularly maintained and thoroughly cleaned and sanitized before each trip. We prioritize your safety and hygiene, ensuring a comfortable and safe environment for your journey to Mahabaleshwar."
    },
    {
        "WhyChooseheading": "Multiple Payment Options for Easy Booking",
        "WhyChoosedescription": "We offer a variety of payment methods, including UPI, credit/debit cards, digital wallets, and cash, making it easy and secure to complete your Tempo Traveller booking for your Pune to Mahabaleshwar trip."
    }
]



























    }

const faqData = [
    {
        id: 1,
        question: 'How do I book a Tempo Traveller from Pune to Mahabaleshwar with Samarth Travels?',
        answer: 'Booking a Tempo Traveller from Pune to Mahabaleshwar is simple with Samarth Travels. You can reserve your vehicle online or by calling our team. Just share your travel date, group size, and pickup location, and we’ll take care of the rest.',
    },
    {
        id: 2,
        question: 'What Tempo Traveller options are available for Pune to Mahabaleshwar?',
        answer: 'We offer a range of Tempo Travellers including 12-seater, 15-seater, 17-seater, and even 25-seater options. All vehicles are equipped with AC, comfortable pushback seats, ample legroom, and space for luggage—perfect for the scenic ride to Mahabaleshwar.',
    },
    {
        id: 3,
        question: 'What are the charges for Tempo Traveller rental from Pune to Mahabaleshwar?',
        answer: 'Rates start from ₹30/km depending on the Tempo Traveller size. We also offer fixed outstation packages with per-day km limits to make your trip affordable. Please contact us for a customized quote based on your itinerary.',
    },
    {
        id: 4,
        question: 'Is the Tempo Traveller comfortable for hill station travel like Mahabaleshwar?',
        answer: 'Yes, our Tempo Travellers are ideal for hill station travel. With strong suspension, experienced drivers, and comfortable interiors, you’ll enjoy a smooth ride to Mahabaleshwar—even on winding mountain roads.',
    },
    {
        id: 5,
        question: 'Can I plan stops or sightseeing along the route to Mahabaleshwar?',
        answer: 'Absolutely! We offer customizable travel plans. You can request stops at places like Panchgani or Mapro Garden along the way. Just let us know your preferences at the time of booking.',
    },
    {
        id: 6,
        question: 'Does the Pune to Mahabaleshwar Tempo Traveller rental include a driver and fuel?',
        answer: 'Yes, your rental includes a professional driver and fuel. Additional charges like tolls or parking fees are communicated transparently before your journey.',
    },
    {
        id: 7,
        question: 'Is customer support available during the trip?',
        answer: 'Yes, our 24/7 customer support is available throughout your trip. Whether it’s route changes, emergencies, or assistance, we’re just a call away.',
    },
];

const testimonials = [
    {
        name: 'Mr. Ajay Shinde',
        role: 'Family Trip Organizer',
        text: 'We booked a 17-seater Tempo Traveller from Pune to Mahabaleshwar for a weekend trip. The vehicle was clean, spacious, and had great AC. Our driver was friendly and knew the route well. Excellent service from Samarth Travels!',
        image: '/img/testimonial/testi_tempo_ajay.jpg',
    },
    {
        name: 'Ms. Meenal Patil',
        role: 'Travel Enthusiast',
        text: 'Our girls’ trip to Mahabaleshwar was made amazing by Samarth Travels. The 12-seater Tempo Traveller was very comfortable and safe. Booking was easy, and their support team was responsive. Highly recommended!',
        image: '/img/testimonial/testi_tempo_meenal.jpg',
    },
];





































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mahabaleshwar Tempo Traveller",
  "image": "https://samarthtravels.com/assets/images/pune-to-mahabaleshwar-tempo-traveller.jpg",
  "description": "Book a Tempo Traveller from Pune to Mahabaleshwar with Samarth Travels. Ideal for family outings, group tours, and corporate trips. Options include 14-seater and 17-seater AC Tempo Travellers for Mahabaleshwar, Panchgani, and Tapola with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5200",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/pune-to-mahabaleshwar-tempo-traveller"
  }
};





    return (
        <div>


<Helmet>
  <title>Pune to Mahabaleshwar Tempo Traveller | 14 & 17-Seater | Samarth Travels</title>
  <meta 
    name="description" 
    content="Rent a Tempo Traveller from Pune to Mahabaleshwar, Panchgani, and Tapola with Samarth Travels. Choose from 14-seater or 17-seater AC travellers for family, group, or corporate tours." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mahabaleshwar Tempo Traveller, Tempo traveller from Pune to Mahabaleshwar, Pune to Mahabaleshwar tempo traveller hire, Pune to Panchgani tempo traveller, Tempo traveller for rent in Pune, Tempo traveller 17 seater for Mahabaleshwar trip, 17 seater tempo traveller for Mahabaleshwar tour package, Pune Airport to Mahabaleshwar Tempo Traveller on rent, Pune to Tapola tempo traveller on rent, 14 seater tempo traveller for Maharashtra trip, Tempo traveller on rent Mahabaleshwar outings, Mini bus on rent for Mahabaleshwar trip, Pune station to Mahabaleshwar tempo traveller on rent, Pune to Panchgani tempo traveller on rent, Pune tempo traveller hire for outstation, Samarth Travels Tempo Traveller" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/54.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomahabaleshwartempotraveller;